import { updateNavigationTopOffsetPropertyOnResize } from './navigation_top_offset';
window.up.compiler('.js-mobile_navigation', element => {
    return updateNavigationTopOffsetPropertyOnResize('mobile', element);
});
window.up.compiler('.js-desktop_navigation', element => {
    return updateNavigationTopOffsetPropertyOnResize('desktop', element);
});
